import React from "react";

export const DIAS = [["seg", "Seg"], ["ter", "Ter"], ["qua", "Qua"], ["qui", "Qui"], ["sex", "Sex"], ["sab", "Sáb"], ["dom", "Dom"]];
export const diasLabel = (dias) => (dias || []).map((d) => DIAS.find((x) => x[0] === d)?.[1] || d).join(", ");
export const freqLabel = (c, FREQ) => c?.frequencia === "dias_semana" ? `Dias fixos: ${diasLabel(c.dias_cobranca)}` : (FREQ?.[c?.frequencia] || c?.frequencia);

/** Caixas Seg…Dom para a frequência "Dias da semana" (mínimo 1). */
export const DiasSemana = ({ value = [], onChange, testid = "dias" }) => (
  <div className="space-y-1" data-testid={`${testid}-semana`}>
    <div className="flex flex-wrap gap-1.5">
      {DIAS.map(([k, l]) => {
        const on = value.includes(k);
        return <button type="button" key={k} onClick={() => onChange(on ? value.filter((x) => x !== k) : DIAS.map((d) => d[0]).filter((d) => d === k || value.includes(d)))}
          className={`h-9 px-3 rounded-full text-xs font-semibold border transition-colors ${on ? "bg-onyx text-white border-onyx" : "bg-white text-slate-600 border-slate-300"}`} data-testid={`${testid}-${k}`} aria-pressed={on}>{l}</button>;
      })}
    </div>
    {value.length === 0 && <p className="text-xs text-red-600" data-testid={`${testid}-erro`}>Selecione pelo menos um dia da semana.</p>}
  </div>
);
